
export const routes = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/',
    component: () => import('@/layouts/default.vue'),
    meta: { requiresAuth: true },
    children: [

      // analitycs
      {
        path: 'marcacion',
        component: () => import('@/pages/marcacion.vue'),
        meta: { roles: ['admin', 'tesoreria', 'employee', 'accounting'] },
      },

      { path: 'dashboard', component: () => import('@/pages/dashboard.vue') },


      // personal data
      { path: 'viatics', component: () => import('@/pages/viatics.vue'), meta: { roles: ['admin', 'tesoreria', 'employee', 'accounting'] } },
      { path: 'myviatics', component: () => import('@/pages/myviatics.vue'), meta: { roles: ['admin', 'tesoreria', 'employee', 'accounting'] } },

      // gestion del sistema
      { path: 'list-users', component: () => import('@/pages/list-users.vue'), meta: { roles: ['admin'] } },


      // configuracion del sistema
      { path: 'config-doc', component: () => import('@/pages/config-system.vue'), meta: { roles: ['admin', 'tesoreria'] } },
      { path: 'proyect', component: () => import('@/pages/list-client-proyect.vue'), meta: { roles: ['admin'] } },
      { path: 'company-info', component: () => import('@/pages/view.companySettings.vue'), meta: { roles: ['admin'] } },
      { path: 'platform', component: () => import('@/pages/view.platformSettings.vue'), meta: { roles: ['admin'] } },

    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/blank.vue'),
    children: [
      {
        path: 'login',
        component: () => import('@/pages/login.vue'),
        meta: { requiresGuest: true },
      },
      {
        path: 'register',
        component: () => import('@/pages/register.vue'),
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/[...error].vue'),
      },
    ],
  },
]
